import { FunctionComponent, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-light-svg-icons';
import { CustomButton } from '@foxtrotplatform/developer-platform-common-ui-component-lib';

interface NavigateToConsoleButtonProps {
  consoleUrl: string;
}

export const NavigateToConsoleButton: FunctionComponent<
  NavigateToConsoleButtonProps
> = ({ consoleUrl }) => {
  const onClick = useCallback(() => {
    sessionStorage.clear();
    window.location.replace(`https:\\\\${consoleUrl}` as string);
  }, [consoleUrl]);
  return (
    <CustomButton
      actionType="primary"
      onClick={onClick}
      testId="success-step-navigate-os1-btn"
      className="px-6"
    >
      <span className="font-bold whitespace-nowrap overflow-hidden">
        Go to OS1
      </span>
      <FontAwesomeIcon icon={faArrowRight} className="text-white pl-3" />
    </CustomButton>
  );
};
